// extracted by mini-css-extract-plugin
export default {"generalLink":"ShippingPolicy_generalLink__RN6JZ","shippingPolicyDiv":"ShippingPolicy_shippingPolicyDiv__NrYFm"};